// Infinite horizontal append for the collection-rows section. Each row
// server-renders its first page of products; scrolling near the right edge
// fetches and appends the next page of that collection via the Section
// Rendering API (same technique as the single-collection infinite scroll).
(function () {
  const THRESHOLD_PX = 600; // start loading this far from the right edge

  function initRow(scroller) {
    const grid = scroller.querySelector('.product-grid');
    const collectionUrl = scroller.dataset.collectionUrl;
    const total = parseInt(scroller.dataset.total, 10) || 0;

    let shown = parseInt(scroller.dataset.shown, 10) || 0;
    let nextPage = parseInt(scroller.dataset.nextPage, 10) || 2;
    let loading = false;
    let done = !grid || !collectionUrl || shown >= total;

    if (done) return;

    async function loadNext() {
      if (loading || done) return;

      const rightGap = scroller.scrollWidth - scroller.scrollLeft - scroller.clientWidth;
      if (rightGap > THRESHOLD_PX) return;

      loading = true;
      try {
        // Fetch the collection's own paginated page and lift its product grid.
        const url = new URL(collectionUrl, window.location.origin);
        url.searchParams.set('page', String(nextPage));

        const res = await fetch(url.toString());
        if (!res.ok) throw new Error('HTTP ' + res.status);

        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fetchedGrid = doc.getElementById('product-grid');
        const items = fetchedGrid
          ? fetchedGrid.querySelectorAll(':scope > li.grid__item:not(.collection__image)')
          : [];

        if (!items.length) {
          done = true;
          return;
        }

        items.forEach((item) => grid.appendChild(item));
        shown += items.length;
        nextPage += 1;
        if (shown >= total) done = true;
      } catch (err) {
        console.error('[collection-rows] failed to load next page', err);
        // leave `done` false so a later scroll can retry
      } finally {
        loading = false;
        // Keep filling while the end is still within range (e.g. short rows).
        if (!done) loadNext();
      }
    }

    scroller.addEventListener('scroll', loadNext, { passive: true });
    // Fill immediately in case the first page doesn't overflow the viewport.
    loadNext();
  }

  function init() {
    document
      .querySelectorAll('.collection-rows__scroller[data-collection-url]')
      .forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
